export default __webpack_public_path__ + "static/media/points.b66cf845.svg";